import { render, staticRenderFns } from "./ArchiveDocumentEditDialog.vue?vue&type=template&id=7fd1ea1f&"
import script from "./ArchiveDocumentEditDialog.vue?vue&type=script&lang=js&"
export * from "./ArchiveDocumentEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports